/**
 * The Daily Check-in's questions, copied from production.
 *
 * The second question is tailored to the customer's latest Bottleneck type;
 * the first is always energy. An account whose type has no entry — or who has
 * no Bottleneck result at all — gets `DEFAULT_QUESTIONS`.
 */
export type CheckinQuestion = { id: string; label: string; low: string; high: string };

export const TYPE_CHECKIN_QUESTIONS: Record<string, CheckinQuestion[]> = {
  'overextended-achiever': [
    { id: 'energy', label: 'Energy level', low: 'Completely depleted', high: 'Fully recharged' },
    {
      id: 'focus',
      label: 'How focused were you on your top priority today?',
      low: 'Scattered across everything',
      high: 'Locked in on one thing',
    },
  ],
  'avoidant-high-performer': [
    { id: 'energy', label: 'Energy level', low: 'Completely depleted', high: 'Fully recharged' },
    {
      id: 'focus',
      label: 'How much did you act on your most important task today?',
      low: 'Avoided it entirely',
      high: 'Made real progress',
    },
  ],
  'isolated-operator': [
    { id: 'energy', label: 'Energy level', low: 'Completely depleted', high: 'Fully recharged' },
    {
      id: 'focus',
      label: 'How connected did you feel to others or outside input today?',
      low: 'Fully isolated',
      high: 'Actively collaborative',
    },
  ],
  'identity-pressured-performer': [
    { id: 'energy', label: 'Energy level', low: 'Completely depleted', high: 'Fully recharged' },
    {
      id: 'focus',
      label: 'How regulated did you feel emotionally today?',
      low: 'Reactive and disrupted',
      high: 'Calm and steady',
    },
  ],
  'scattered-builder': [
    { id: 'energy', label: 'Energy level', low: 'Completely depleted', high: 'Fully recharged' },
    {
      id: 'focus',
      label: 'How clear was your direction and priorities today?',
      low: 'No clarity at all',
      high: 'Crystal clear focus',
    },
  ],
  'under-recovered-performer': [
    { id: 'energy', label: 'Energy level', low: 'Completely depleted', high: 'Fully recharged' },
    {
      id: 'focus',
      label: 'How well did you protect time for rest and recovery today?',
      low: 'Pushed through everything',
      high: 'Prioritized recovery',
    },
  ],
};

export const DEFAULT_QUESTIONS: CheckinQuestion[] = [
  { id: 'energy', label: 'Energy level', low: 'Completely depleted', high: 'Fully recharged' },
  { id: 'focus', label: 'Focus level', low: 'Completely scattered', high: 'Fully locked in' },
];

export function questionsFor(typeSlug: string | null): CheckinQuestion[] {
  return (typeSlug ? TYPE_CHECKIN_QUESTIONS[typeSlug] : undefined) ?? DEFAULT_QUESTIONS;
}

/** Whether production shows its "Questions tailored to your type" line. */
export function isTailored(typeSlug: string | null): boolean {
  return typeSlug !== null && TYPE_CHECKIN_QUESTIONS[typeSlug] !== undefined;
}
